import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { ErrorBoundary } from "react-error-boundary";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import LogoutIcon from '@mui/icons-material/Logout';
import ReplayIcon from '@mui/icons-material/Replay';
function Fallback({ error, resetErrorBoundary }) {
    const goGrid = () => {
        window.location.href = '/grid';
    };
    const goLogoff = () => {
        window.location.href = '/app/logoff';
    };
    return (_jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, xs: 12, children: _jsx(Typography, { fontWeight: "bold", children: "Something went wrong:" }) }), _jsx(Grid, { item: true, xs: 12, children: _jsxs(Alert, { sx: { my: 1 }, severity: 'warning', children: [_jsx("strong", { children: error.name }), ":", error.message] }) }), _jsxs(Grid, { item: true, xs: 12, children: [_jsx(Button, { variant: 'contained', startIcon: _jsx(ReplayIcon, {}), onClick: resetErrorBoundary, children: "Try again" }), _jsx(Button, { sx: { mx: 1 }, variant: 'contained', startIcon: _jsx(CalendarMonthIcon, {}), onClick: goGrid, children: "Back to grid" }), _jsx(Button, { variant: 'contained', startIcon: _jsx(LogoutIcon, {}), onClick: goLogoff, children: "Log off" })] })] }));
}
export default function GlobalErrorBoundary({ children }) {
    return (_jsx(Box, { children: _jsx(ErrorBoundary, { FallbackComponent: Fallback, onReset: (details) => {
                // Reset the state of your app so the error doesn't happen again
                console.log(details);
            }, children: children }) }));
}
